import { GET_ENROLLED_SKILLS, SET_ALL_COURSES } from "../actions/types";

export default function (state = [], action) {
    switch (action.type) {
        case SET_ALL_COURSES:
            return {
                ...state,
                allCourses: action?.payload
            }
        case GET_ENROLLED_SKILLS:
            return {
                ...state,
                enrolledSkills: action?.payload
            }
        default:
            return state;
    }
}